<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-3">
        <b-field>
          <form-input :label="`${$t('documents.fields.title')} *`" v-model="form.name"></form-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-select :label="`${$t('documents.filters.type')} *`" v-model="form.type">
            <option value="info">{{ $t('workflow.doctypes.info') }}</option>
            <option value="task">{{ $t('workflow.doctypes.task') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-select :label="`${$t('documents.filters.priority')} *`" v-model="form.priority">
            <option value="low">{{ $t('workflow.priorities.low') }}</option>
            <option value="medium">{{ $t('workflow.priorities.medium') }}</option>
            <option value="high">{{ $t('workflow.priorities.high') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-select :label="`${$t('documents.fields.sourceType')} *`" v-model="form.source_type">
            <option value="standalone">{{ $t('documents.sourceTypes.standalone') }}</option>
            <option value="project">{{ $t('documents.sourceTypes.project') }}</option>
            <option value="program">{{ $t('documents.sourceTypes.program') }}</option>
          </form-select>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field>
          <form-textarea :label="`${$t('interface.description')} *`" v-model="form.description"></form-textarea>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <form-datepicker :label="$t('documents.fields.term')" v-model="form.term_date"
                           :min-date="minDate"></form-datepicker>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <EmployeeSelect :initials.sync="form.executive_maintainer__initials"
                          :label="`${$t('documents.executive_maintainer')} *`"
                          :scope-all="isDocflowApprover"
                          v-model="form.executive_maintainer">
          </EmployeeSelect>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <EmployeeSelect :initials.sync="form.maintainer__initials"
                          :label="`${$t('documents.maintainer')} *`"
                          :scope-all="isDocflowApprover"
                          v-model="form.maintainer">
          </EmployeeSelect>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field>
          <DocumentSelect :name="form.document__registration_number"
                          @select="onDocumentChange"
                          :label="$t('documents.document')"
                          v-model="form.document">
          </DocumentSelect>
        </b-field>
      </div>
      <div class="column is-12">
        <div class="field is-grouped mt-10">
          <div class="control">
            <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
          </div>
          <div class="control">
            <button class="button is-danger" @click="cancel">{{ $t('interface.cancel') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {prepareDate} from '@/utils'
  import EmployeeSelect from '@/components/EmployeeSelect'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'
  import DocumentSelect from '@/components/DocumentSelect'
  import moment from 'moment'

  const defaultDocumentData = {
    name: '',
    document: null,
    document__registration_number: null,
    source__name: null,
    description: '',
    type: 'task',
    priority: 'low',
    source_type: 'standalone',
    term_date: null,
    maintainer: null,
    maintainer__initials: null,
    executive_maintainer: null,
    executive_maintainer__initials: null
  }

  export default {
    props: ['documentData', 'editMode'],
    components: {
      EmployeeSelect,
      DocumentSelect,
      GovernmentAgencySelect
    },
    data() {
      return {
        form: this.documentData || {...defaultDocumentData},
        isEdit: this.editMode || false,
        errors: [],
        minDate: moment().subtract(1, 'days').toDate(),
        maxDate: new Date()
      }
    },
    methods: {
      validate() {
        this.errors = []
        if (this.form.name === '' || this.form.description === '') {
          this.errors.push(this.$t('interface.requiredFields'))
        }
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            term_date: this.form.term_date ? prepareDate(this.form.term_date) : null
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      },
      onDocumentChange() {
        this.form.document__registration_number = null
      }
    },
    computed: {
      ...mapState('Document', ['docTypes']),
      ...mapGetters('Document', ['getProjectById']),
      ...mapGetters('Account', ['isDocflowApprover']),
    },
    watch: {
      'form.executive_maintainer'() {
        if(this.form.maintainer === null) {
          this.form.maintainer = this.form.executive_maintainer
          this.form.maintainer__initials = this.form.executive_maintainer__initials
        }
      },
      documentData(document) {
        this.form = document
      }
    }
  }
</script>
